
// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

// const formatLastLogin = (value) => {
//   if (!value) return "Never";

//   const date = new Date(value);

//   if (Number.isNaN(date.getTime())) {
//     return "Unknown";
//   }

//   const diffMs = Date.now() - date.getTime();
//   const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

//   if (diffHours < 1) {
//     return "Just now";
//   }

//   if (diffHours < 24) {
//     return `${diffHours}h ago`;
//   }

//   const diffDays = Math.floor(diffHours / 24);

//   if (diffDays === 1) {
//     return "Yesterday";
//   }

//   if (diffDays < 30) {
//     return `${diffDays}d ago`;
//   }

//   return date.toLocaleDateString("en-IN");
// };

// const mapDashboardResponse = (api) => {
//   const kpi = api.kpi || {};
//   const login = api.login_buckets || {};
//   const jobs = api.completed_job_buckets || {};
//   const profileHealth = api.profile_health || {};
//   const recentSnappers = api.recent_snappers || [];

//   const registered = kpi.registered || 0;
//   const active = kpi.active || 0;

//   const photoOnboarding = profileHealth.is_completed_photo_job || 0;
//   const videoOnboarding = profileHealth.is_completed_video_job || 0;
//   const blocked = profileHealth.blocked || 0;

//   return {
//     filters: {
//       countries: [
//         "All Countries",
//         ...(api.filters?.countries || [])
//       ],
//       states: [
//         "All States",
//         ...(api.filters?.states || [])
//       ],
//       cities: [
//         "All Cities",
//         ...(api.filters?.cities || [])
//       ]
//     },

//     kpis: {
//       registered,
//       active,
//       worked30: kpi.worked_30d || 0,
//       dormant180: login.days_180_plus || 0
//     },

//     profileHealth: {
//       photoOnboarding,
//       photoOnboardingPct: registered ? ((photoOnboarding / registered) * 100).toFixed(1) : "0.0",
//       videoOnboarding,
//       videoOnboardingPct: registered ? ((videoOnboarding / registered) * 100).toFixed(1) : "0.0",
//       blocked,
//       blockedPct: registered ? ((blocked / registered) * 100).toFixed(1) : "0.0"
//     },

//     loginWindows: [
//       { label: "Last 30 days", value: login.days_0_30 || 0, pct: registered ? ((login.days_0_30 / registered) * 100).toFixed(1) : 0 },
//       { label: "31–60 days", value: login.days_31_60 || 0, pct: registered ? ((login.days_31_60 / registered) * 100).toFixed(1) : 0 },
//       { label: "61–90 days", value: login.days_61_90 || 0, pct: registered ? ((login.days_61_90 / registered) * 100).toFixed(1) : 0 },
//       { label: "91–180 days", value: login.days_91_180 || 0, pct: registered ? ((login.days_91_180 / registered) * 100).toFixed(1) : 0 },
//       { label: "180+ days", value: login.days_180_plus || 0, pct: registered ? ((login.days_180_plus / registered) * 100).toFixed(1) : 0 },
//       { label: "Never / missing", value: login.never_or_missing || 0, pct: registered ? ((login.never_or_missing / registered) * 100).toFixed(1) : 0 }
//     ],

//     jobsWindows: [
//       {
//         label: "Last 30 days",
//         value: jobs.days_0_30 || 0,
//         pct: registered ? Math.min(100, ((jobs.days_0_30 / registered) * 100)).toFixed(1) : 0
//       },
//       {
//         label: "Last 60 days",
//         value: jobs.days_0_60 || 0,
//         pct: registered ? Math.min(100, ((jobs.days_0_60 / registered) * 100)).toFixed(1) : 0
//       },
//       {
//         label: "Last 90 days",
//         value: jobs.days_0_90 || 0,
//         pct: registered ? Math.min(100, ((jobs.days_0_90 / registered) * 100)).toFixed(1) : 0
//       },
//       {
//         label: "Last 180 days",
//         value: jobs.days_0_180 || 0,
//         pct: registered ? Math.min(100, ((jobs.days_0_180 / registered) * 100)).toFixed(1) : 0
//       },
//       {
//         label: "180+ days",
//         value: jobs.days_180_plus || 0,
//         pct: registered ? Math.min(100, ((jobs.days_180_plus / registered) * 100)).toFixed(1) : 0
//       }
//     ],

//     cities: (api.city_coverage || []).map(row => ({
//       city: row.city || "Unknown",
//       state: row.state || "Unknown",
//       registered: row.registered || 0,
//       active: row.active || 0,
//       worked30: row.worked_30d || 0,
//       capacity: row.capacity || 0,
//       share: row.share || 0,
//       signal: row.signal || "Unknown"
//     })),

//     states: (api.states || []).map(row => ({
//       name: row.name,
//       registered: row.registered || 0,
//       worked30: row.worked30 || 0
//     })),

//     snappers: recentSnappers.map(person => ({
//       id: person.id,
//       name: person.public_name || person.name || person.username || "Unknown",
//       city: person.city || "Unknown",
//       state: person.state || "Unknown",
//       type: person.type || "Snapper",
//       jobs30: person.completed_jobs_30d || 0,
//       lastLogin: formatLastLogin(person.last_login_at),
//       readiness: person.readiness || "Unknown",
//       avatarUrl: person.avatarUrl || ""
//     })),

//     locationPoints: api.location_points || []
//   };
// };

// export const getSnapperInsightDashboard = async (userId, filters = {}) => {
//   const params = new URLSearchParams();

//   if (filters.country && filters.country !== "All Countries") {
//     params.append("country_code", filters.country);
//   }

//   if (filters.city && filters.city !== "All Cities") {
//     params.append("city", filters.city);
//   }

//   const queryString = params.toString();

//   const url =
//     `${API_URL}/api/snapper-insights/dashboard` +
//     (queryString ? `?${queryString}` : "");

//   const response = await fetch(url, {
//     method: "GET",
//     headers: {
//       "X-User-ID": String(userId)
//     }
//   });

//   if (!response.ok) {
//     const text = await response.text();
//     throw new Error(
//       `Snapper Insight API failed: ${response.status} ${text}`
//     );
//   }

//   const apiResponse = await response.json();
//   return mapDashboardResponse(apiResponse);
// };

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const formatLastLogin = (value) => {
  if (!value) return "Never";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "Unknown";
  }

  const diffMs = Date.now() - date.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

  if (diffHours < 1) {
    return "Just now";
  }

  if (diffHours < 24) {
    return `${diffHours}h ago`;
  }

  const diffDays = Math.floor(diffHours / 24);

  if (diffDays === 1) {
    return "Yesterday";
  }

  if (diffDays < 30) {
    return `${diffDays}d ago`;
  }

  return date.toLocaleDateString("en-IN");
};

const mapDashboardResponse = (api) => {
  const kpi = api.kpi || {};
  const login = api.login_buckets || {};
  const jobs = api.completed_job_buckets || {};
  const profileHealth = api.profile_health || {};
  const recentSnappers = api.recent_snappers || [];

  const registered = kpi.registered || 0;
  const active = kpi.active || 0;

  const photoOnboarding = profileHealth.is_completed_photo_job || 0;
  const videoOnboarding = profileHealth.is_completed_video_job || 0;
  const blocked = profileHealth.blocked || 0;

  return {
    filters: {
      countries: [
        "All Countries",
        ...(api.filters?.countries || [])
      ],
      states: [
        "All States",
        ...(api.filters?.states || [])
      ],
      cities: [
        "All Cities",
        ...(api.filters?.cities || [])
      ]
    },

    kpis: {
      registered,
      active,
      worked30: kpi.worked_30d || 0,
      dormant180: login.days_180_plus || 0
    },

    profileHealth: {
      photoOnboarding,
      photoOnboardingPct: registered ? ((photoOnboarding / registered) * 100).toFixed(1) : "0.0",
      videoOnboarding,
      videoOnboardingPct: registered ? ((videoOnboarding / registered) * 100).toFixed(1) : "0.0",
      blocked,
      blockedPct: registered ? ((blocked / registered) * 100).toFixed(1) : "0.0"
    },

    loginWindows: [
      { label: "Last 30 days", value: login.days_0_30 || 0, pct: registered ? ((login.days_0_30 / registered) * 100).toFixed(1) : 0 },
      { label: "31–60 days", value: login.days_31_60 || 0, pct: registered ? ((login.days_31_60 / registered) * 100).toFixed(1) : 0 },
      { label: "61–90 days", value: login.days_61_90 || 0, pct: registered ? ((login.days_61_90 / registered) * 100).toFixed(1) : 0 },
      { label: "91–180 days", value: login.days_91_180 || 0, pct: registered ? ((login.days_91_180 / registered) * 100).toFixed(1) : 0 },
      { label: "180+ days", value: login.days_180_plus || 0, pct: registered ? ((login.days_180_plus / registered) * 100).toFixed(1) : 0 },
      { label: "Never / missing", value: login.never_or_missing || 0, pct: registered ? ((login.never_or_missing / registered) * 100).toFixed(1) : 0 }
    ],

    jobsWindows: [
      {
        label: "Last 30 days",
        value: jobs.days_0_30 || 0,
        pct: registered ? Math.min(100, ((jobs.days_0_30 / registered) * 100)).toFixed(1) : 0
      },
      {
        label: "Last 60 days",
        value: jobs.days_0_60 || 0,
        pct: registered ? Math.min(100, ((jobs.days_0_60 / registered) * 100)).toFixed(1) : 0
      },
      {
        label: "Last 90 days",
        value: jobs.days_0_90 || 0,
        pct: registered ? Math.min(100, ((jobs.days_0_90 / registered) * 100)).toFixed(1) : 0
      },
      {
        label: "Last 180 days",
        value: jobs.days_0_180 || 0,
        pct: registered ? Math.min(100, ((jobs.days_0_180 / registered) * 100)).toFixed(1) : 0
      },
      {
        label: "180+ days",
        value: jobs.days_180_plus || 0,
        pct: registered ? Math.min(100, ((jobs.days_180_plus / registered) * 100)).toFixed(1) : 0
      }
    ],

    cities: (api.city_coverage || []).map(row => ({
      city: row.city || "Unknown",
      state: row.state || "Unknown",
      registered: row.registered || 0,
      active: row.active || 0,
      worked30: row.worked_30d || 0,
      capacity: row.capacity || 0,
      share: row.share || 0,
      signal: row.signal || "Unknown"
    })),

    states: (api.states || []).map(row => ({
      name: row.name,
      registered: row.registered || 0,
      worked30: row.worked30 || 0
    })),

    snappers: recentSnappers.map(person => ({
      id: person.id,
      name: person.public_name || person.name || person.username || "Unknown",
      city: person.city || "Unknown",
      state: person.state || "Unknown",
      type: person.type || "Snapper",
      jobs30: person.completed_jobs_30d || 0,
      lastLogin: formatLastLogin(person.last_login_at),
      readiness: person.readiness || "Unknown",
      avatarUrl: person.avatarUrl || ""
    })),

    locationPoints: api.location_points || []
  };
};

export const getSnapperInsightDashboard = async (userId, filters = {}) => {
  const params = new URLSearchParams();

  if (filters.country && filters.country !== "All Countries") {
    params.append("country_code", filters.country);
  }

  if (filters.city && filters.city !== "All Cities") {
    params.append("city", filters.city);
  }

  const queryString = params.toString();

  const url =
    `${API_URL}/api/snapper-insights/dashboard` +
    (queryString ? `?${queryString}` : "");

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "X-User-ID": String(userId)
    }
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(
      `Snapper Insight API failed: ${response.status} ${text}`
    );
  }

  const apiResponse = await response.json();
  return mapDashboardResponse(apiResponse);
};

export const getSnapperMapData = async (userId) => {
  const response = await fetch(
    `${API_URL}/api/snapper-insights/map?user_id=${encodeURIComponent(userId)}`
  );

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Failed to load snapper map data");
  }

  return response.json();
};